// extracted by mini-css-extract-plugin
module.exports = {"slides":"images_slides__Q2MW9","slide":"images_slide__1vlHK","prevnextbtn":"images_prevnextbtn__yZQu-"};